import styled from "styled-components"
import tw from "twin.macro"

export const SubHeader = tw.p`font-bold text-2xl text-grey-darkest`
export const Span = tw.span`text-grey-darker`
